import React, { useState } from "react";
import { Navigate, Routes, Route, useLocation } from "react-router-dom";
import { CookiesProvider, useCookies } from "react-cookie";
import { ToastContainer, toast } from "react-toastify";
import { AnimatePresence } from "framer-motion";
import {
  AuthProvider,
  NotOpenLogin,
  ProtectedRoute,
} from "./Constants/AuthProvider";
import { ConfirmationModalProvider } from "./fautures/ConfirmationModalProvider";
import MainPage from "./pages/MainPage/MainPage";
import { AuthContext } from "./Constants/AuthProvider";
import Login from "./pages/Login/Login";
import PaymentVerify from "./PaymentVerify";
import ServerStatus from "./pages/ServerStatus/ServerStatus";
import Layout from "./pages/layout/Layout";
import AccountSettings from "./pages/AccountSettings/AccountSettings.module";
import NewProfile from "./pages/NewProfile/NewProfile.module";
import LearninCenter from "./pages/LearningCenter/LearninCenter";
import { PageWrapper } from "./Components/PageWrapper/PageWrapper";
import Loading from "./Components/Loading/Loading.module";
import TrackOnRouteChange from "./Components/TrackOnRouteChange/TrackOnRouteChange.module";
import AccountRenew from "./pages/AccountRenew/AccountRenew";
function App() {
  const [loadingShow, setLoadingShow] = useState(false);
  const location = useLocation();
  return (
    <>
      <CookiesProvider>
        <AuthProvider>
          <ConfirmationModalProvider>
            <TrackOnRouteChange>
              <Routes location={location} key={location.pathname}>
                <Route path="/verify" element={<PaymentVerify />} />
                <Route element={<NotOpenLogin />}>
                  <Route path="/login" element={<Login />} />
                </Route>
                <Route element={<ProtectedRoute />}>
                  <Route
                    path="/"
                    element={
                      <PageWrapper>
                        <MainPage
                          setLoadingShow={setLoadingShow}
                          loadingShow={loadingShow}
                        />
                      </PageWrapper>
                    }
                  />
                  <Route
                    path="/account-renew"
                    element={
                      <PageWrapper>
                        <AccountRenew
                          setLoadingShow={setLoadingShow}
                          loadingShow={setLoadingShow}
                        />
                      </PageWrapper>
                    }
                  />
                  <Route
                    path="/account-settings"
                    element={
                      <PageWrapper>
                        <AccountSettings />
                      </PageWrapper>
                    }
                  />
                  <Route
                    path="/server-status"
                    element={
                      <PageWrapper>
                        <ServerStatus />
                      </PageWrapper>
                    }
                  />
                  <Route
                    path="/new-profile"
                    element={
                      <PageWrapper>
                        <NewProfile
                          setLoadingShow={setLoadingShow}
                          loadingShow={loadingShow}
                        />
                      </PageWrapper>
                    }
                  />
                  <Route
                    path="/learning-center"
                    element={
                      <PageWrapper>
                        <LearninCenter />
                      </PageWrapper>
                    }
                  />
                </Route>
              </Routes>
            </TrackOnRouteChange>
            <ToastContainer
              rtl={true}
              closeOnClick={true}
              style={{ fontSize: "13px", fonFamily: "light" }}
              theme="light"
            />
            {loadingShow && <Loading />}
          </ConfirmationModalProvider>
        </AuthProvider>
      </CookiesProvider>
    </>
  );
}

export default App;
